
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type garageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function garageRT(): TemplateResult<garageRTRootProps> {
    function onClick1() {
        window.Convermax.openVehicleDialog();
    }
    return _createElement('div', {}, this.size ? _createElement('div', {
        'className': 'cm_garage garage-container',
        'key': '8'
    }, _createElement('a', {
        'className': 'cm_toggle-dropdown garage-button',
        'title': 'Garage: ' + this.size + ' item(s)',
        'tabIndex': '0',
        'role': 'button'
    }, _createElement('div', { 'className': 'garage-icon-container' }, _createElement('span', { 'className': 'custom-garage-icon' }, _createElement('svg', {
        'width': '24',
        'height': '24',
        'viewBox': '0 0 24 24',
        'fill': 'none',
        'xmlns': 'http://www.w3.org/2000/svg'
    }, _createElement('path', {
        'd': 'M12 1C5.95 1 1 5.95 1 12C1 18.05 5.95 23 12 23C18.05 23 23 18.05 23 12C23 5.95 18.05 1 12 1ZM2.99375 8.5625C4.36875 4.91875 7.875 2.375 12 2.375C16.125 2.375 19.6313 4.9875 21.0063 8.5625C21.4188 9.6625 20.4563 10.8312 19.2875 10.4875L17.0875 9.9375H17.0187H16.8813C13.65 9.1125 10.2812 9.1125 7.11875 9.9375H6.98125L6.9125 10.0063L4.7125 10.5562C3.54375 10.8313 2.58125 9.6625 2.99375 8.5625ZM11.2437 19.8375C11.2437 20.8 10.35 21.4875 9.3875 21.2125C5.95 20.25 3.26875 17.4312 2.58125 13.8563C2.44375 13.1 2.925 12.3438 3.68125 12.1375C5.46875 11.725 7.325 12.2063 8.5625 13.5125L9.8 14.75C10.7625 15.7125 11.2437 17.0187 11.2437 18.3937V19.8375ZM10.8312 12.2062C10.8312 11.5187 11.3813 10.9688 12.0688 10.9688C12.7563 10.9688 13.3062 11.5187 13.3062 12.2062C13.3062 12.8937 12.7563 13.4438 12.0688 13.4438C11.3813 13.4438 10.8312 12.8937 10.8312 12.2062ZM14.5437 21.2812C13.5812 21.5562 12.6187 20.8687 12.6187 19.9062V18.5312C12.6187 17.1562 13.1687 15.85 14.1313 14.8875L15.3687 13.65C16.675 12.3438 18.5312 11.8625 20.3188 12.275C21.075 12.4812 21.5562 13.2375 21.4187 13.9937C20.6625 17.5 17.9812 20.3188 14.5437 21.2812Z',
        'fill': 'url(#paint0_linear_1977_2809)',
        'stroke': 'url(#paint1_linear_1977_2809)'
    }), _createElement('defs', {}, _createElement('linearGradient', {
        'id': 'paint0_linear_1977_2809',
        'x1': '12',
        'y1': '1',
        'x2': '12',
        'y2': '23',
        'gradientUnits': 'userSpaceOnUse'
    }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
        'offset': '1',
        'stopColor': '#27AAE1'
    })), _createElement('linearGradient', {
        'id': 'paint1_linear_1977_2809',
        'x1': '12',
        'y1': '1',
        'x2': '12',
        'y2': '23',
        'gradientUnits': 'userSpaceOnUse'
    }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
        'offset': '1',
        'stopColor': '#27AAE1'
    })))))), _createElement('span', { 'className': 'garage-label' }, this.vehicleString || _translate(`garage_title`))), [this.garageDropdown(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', { 'className': 'garage-item' }, _createElement('span', {
                            'className': 'select-model',
                            'onClick': this.selectVehicle
                        }, this.vehicleString), _createElement('span', {
                            'className': 'remove-model',
                            'onClick': this.removeVehicle
                        }, [_createElement('span', {
                                'className': 'material-symbols-outlined cancel',
                                'key': '1930'
                            }, ' cancel ')]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_garageDropdown' }, this.template === 'list' ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '31'
            }, _createElement('div', { 'className': 'garage-content' }, _createElement('div', {
                'className': 'clear-garage',
                'onClick': this.clearGarage
            }, _translate(`garage_clear`)), _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  button button--primary button--small cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })])) : null, this.template === 'empty' ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '1248'
            }, _createElement('div', { 'className': 'garage-content' }, [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  button button--primary button--small cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], _createElement('ul', {}, _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_one`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_two`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_three`))))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]) : null, !this.size ? _createElement('div', {
        'className': 'cm_garage garage-container',
        'key': '4820'
    }, _createElement('a', {
        'className': 'cm_toggle-dropdown garage-button',
        'tabIndex': '0',
        'role': 'button',
        'onClick': onClick1.bind(this)
    }, _createElement('div', { 'className': 'garage-icon-container' }, _createElement('span', { 'className': 'custom-garage-icon' }, _createElement('svg', {
        'width': '24',
        'height': '24',
        'viewBox': '0 0 24 24',
        'fill': 'none',
        'xmlns': 'http://www.w3.org/2000/svg'
    }, _createElement('path', {
        'd': 'M12 1C5.95 1 1 5.95 1 12C1 18.05 5.95 23 12 23C18.05 23 23 18.05 23 12C23 5.95 18.05 1 12 1ZM2.99375 8.5625C4.36875 4.91875 7.875 2.375 12 2.375C16.125 2.375 19.6313 4.9875 21.0063 8.5625C21.4188 9.6625 20.4563 10.8312 19.2875 10.4875L17.0875 9.9375H17.0187H16.8813C13.65 9.1125 10.2812 9.1125 7.11875 9.9375H6.98125L6.9125 10.0063L4.7125 10.5562C3.54375 10.8313 2.58125 9.6625 2.99375 8.5625ZM11.2437 19.8375C11.2437 20.8 10.35 21.4875 9.3875 21.2125C5.95 20.25 3.26875 17.4312 2.58125 13.8563C2.44375 13.1 2.925 12.3438 3.68125 12.1375C5.46875 11.725 7.325 12.2063 8.5625 13.5125L9.8 14.75C10.7625 15.7125 11.2437 17.0187 11.2437 18.3937V19.8375ZM10.8312 12.2062C10.8312 11.5187 11.3813 10.9688 12.0688 10.9688C12.7563 10.9688 13.3062 11.5187 13.3062 12.2062C13.3062 12.8937 12.7563 13.4438 12.0688 13.4438C11.3813 13.4438 10.8312 12.8937 10.8312 12.2062ZM14.5437 21.2812C13.5812 21.5562 12.6187 20.8687 12.6187 19.9062V18.5312C12.6187 17.1562 13.1687 15.85 14.1313 14.8875L15.3687 13.65C16.675 12.3438 18.5312 11.8625 20.3188 12.275C21.075 12.4812 21.5562 13.2375 21.4187 13.9937C20.6625 17.5 17.9812 20.3188 14.5437 21.2812Z',
        'fill': 'url(#paint0_linear_1977_2809)',
        'stroke': 'url(#paint1_linear_1977_2809)'
    }), _createElement('defs', {}, _createElement('linearGradient', {
        'id': 'paint0_linear_1977_2809',
        'x1': '12',
        'y1': '1',
        'x2': '12',
        'y2': '23',
        'gradientUnits': 'userSpaceOnUse'
    }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
        'offset': '1',
        'stopColor': '#27AAE1'
    })), _createElement('linearGradient', {
        'id': 'paint1_linear_1977_2809',
        'x1': '12',
        'y1': '1',
        'x2': '12',
        'y2': '23',
        'gradientUnits': 'userSpaceOnUse'
    }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
        'offset': '1',
        'stopColor': '#27AAE1'
    })))))), _createElement('span', { 'className': 'garage-label' }, this.vehicleString || _translate(`garage_title`)))) : null);
}
        export const componentNames = ["cm:addButton","cm:addButton","cm:garageDropdown"]